/**
 * Invitation expiry time in seconds.
 * Invitations that are not accepted within this window are automatically voided.
 * Default: 7 days.
 */
export const INVITATION_EXPIRES_IN_SECONDS = 7 * 24 * 60 * 60;
export const MAX_ORGANIZATION_NAME_LENGTH = 50;
export const MIN_ORGANIZATION_NAME_LENGTH = 1;
